export type SnapshotWidgetId = 'snapshot_credenciamento' | 'snapshot_indicadores' | 'snapshot_atendimentos' | 'snapshot_engajamento';
export type SnapshotChartId = 'snapshot_trend' | 'snapshot_distribution';

export type SnapshotWidgetConfig = {
  id: SnapshotWidgetId;
  title: string;
  subtitle?: string;
  active: boolean;
  createdAt: string;
  widgetKeys: string[];
  notes?: string;
};

export type SnapshotChartConfig = {
  id: SnapshotChartId;
  title: string;
  subtitle: string;
  createdAt: string;
  widgetId: SnapshotWidgetId;
  notes?: string;
};

export const SNAPSHOT_WIDGETS: SnapshotWidgetConfig[] = [
  {
    id: 'snapshot_credenciamento',
    title: 'Credenciamento',
    subtitle: 'Graficos de andamento e distribuicao',
    active: true,
    createdAt: '2026-01-17',
    widgetKeys: ['coordination'],
    notes: 'Agrupa os graficos de andamento operacional e distribuicao.'
  },
  {
    id: 'snapshot_indicadores',
    title: 'Indicadores de credenciamento',
    subtitle: 'KPIs e deltas do pipeline',
    active: true,
    createdAt: '2026-01-17',
    widgetKeys: ['pipeline_kpis'],
    notes: 'Indicadores consolidados do credenciamento.'
  },
  {
    id: 'snapshot_atendimentos',
    title: 'Atendimentos',
    subtitle: 'SLA e eficiencia do time',
    active: true,
    createdAt: '2026-01-17',
    widgetKeys: ['attendance_kpis'],
    notes: 'Indicadores de atendimento (SLA 1h, backlog e resolucao).'
  },
  {
    id: 'snapshot_engajamento',
    title: 'Engajamento',
    subtitle: 'Volume e distribuicao de interacoes',
    active: true,
    createdAt: '2026-03-10',
    widgetKeys: ['engagement_kpis'],
    notes: 'Indicadores de engajamento (imobiliarias, chamados, categorias).'
  }
];

export const SNAPSHOT_CHARTS: SnapshotChartConfig[] = [
  {
    id: 'snapshot_trend',
    title: 'Andamento operacional',
    subtitle: 'Evolução e tendência de gargalos',
    createdAt: '2026-01-17',
    widgetId: 'snapshot_credenciamento',
    notes: 'Analise operacional com linha de gargalo.'
  },
  {
    id: 'snapshot_distribution',
    title: 'Imobiliarias hoje',
    subtitle: '',
    createdAt: '2026-01-17',
    widgetId: 'snapshot_credenciamento',
    notes: 'Distribuicao por status para leitura rapida.'
  }
];
